<template>
  <div class="modal-backdrop fade show"
       style="z-index: 1055;"
  />
  <transition
      appear
      name="modal"
      duration="1000"
  >
    <div class="modal"
         ref="modalRef"
         tabindex="-1"
         :style="{display: 'block'}"
         :class="props.class"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div v-if="loading"
               class="modal-loader"
          >
            <Spinner/>
          </div>

          <div
              v-if="!headerDisabled"
              class="modal-header"
              :class="headerClass"
          >
            <i v-if="icon"
               :class="icon"
               class="modal-header__icon"
            />

            <slot name="header">
              <span v-html="title" />
            </slot>

            <i class="icon-times modal-close ml-auto action-icon control-icon"
               @click="close"
            />
          </div>


          <div class="modal-body"
               :class="bodyClass"
          >
            <slot v-bind="{close}">
              {{ message }}
            </slot>
          </div>


          <div v-if="!footerDisabled"
               class="modal-footer"
               :class="footerClass"
          >
            <slot name="footer" v-bind="{close}"/>
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>
<script setup>
import Spinner from "@/js/Elements/Spinner.vue";
import {ref} from "vue";

const emit = defineEmits(['close']);
const props = defineProps({
  headerDisabled: Boolean,
  footerDisabled: Boolean,
  headerClass: [String, Array, Object],
  bodyClass: [String, Array, Object],
  footerClass: [String, Array, Object],
  icon: String,
  title: String,
  message: String,
  loading: Boolean,
  class: [String, Array, Object],
  id: [String, Number]
});
const modalRef = ref();
defineExpose({
  close
});

function clickOnModal(e) {
  if (e.target !== modalRef.value) return;
  close();
}

function close() {
  emit('close');
}
</script>
<style scoped lang="scss">
@import "@/css/functions";
@import "@/css/variables";
@import "bootstrap/scss/functions";
@import "bootstrap/scss/mixins";
@import "bootstrap/scss/variables";

.modal {
  &-dialog {
    z-index: 9999;
  }

  &-dialog-centered {
    transition: none;
    display: flex !important;
    align-items: flex-start;
    justify-content: center;
    padding: spacing(2);

    @include media-breakpoint-up(sm) {
      align-items: center;
    }

    .modal-dialog {
      width: 100%;
      margin: auto;
    }
  }

  &-lg {
    @include media-breakpoint-up(md) {
      .modal-dialog {
        max-width: calc(100% - #{spacing(4)});
      }
    }

    @include media-breakpoint-up(lg) {
      .modal-dialog {
        max-width: $modal-lg;
      }
    }
  }

  &-header,
  &-body,
  &-footer {
    background-color: themeColor('base');
  }

  &-loader {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, .8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9;
  }

  &-header {
    height: toRem(56);
    border-bottom: themeColor('border') solid toRem(1);
    font-size: fontSize(2);
    font-weight: $font-weight-semibold;

    &--borderless {
      border-bottom: none;
    }

    &__icon {
      color: themeColor('primary');
      margin-right: spacing(2);
    }
  }

  &-content {
    overflow: hidden;
    border-radius: $border-radius-xxl;
    box-shadow: 0 toRem(5) toRem(12) 0 rgba(0, 0, 0, 0.30),
                0 toRem(-3) toRem(8) toRem(2) rgba(103, 110, 118, 0.08),
                toRem(1) toRem(-2) toRem(8) toRem(1) rgba(0, 0, 0, 0.11);
  }

  &-body {
    padding: spacing(5);

    &:deep(.form .form-error) {
      margin: spacing(2) spacing(4);
      padding: 0;
    }

    :deep(.form .container),
    :deep(> .container) {
      padding: 0 spacing(5);
    }

    :deep(.form-error) {
      margin-top: spacing(5);
    }

    :deep(.container > .row + .row) {
      margin-top: spacing(3);
    }
  }

  &-footer {
    border-top: none;
    padding-right: spacing(4);
    padding-bottom: spacing(4);
    //&--borderless {
    //  border-top: none;
    //}
  }

  &--alert &-body {
    //padding: $modal-alert-body-padding;
  }

  &-close {
    cursor: pointer;
    font-size: fontSize(3);
    padding:  toRem(1.5) 0 0 toRem(1);
  }

  &-enter-active,
  &-leave-active {
    .modal-dialog {
      transition: transform .35s ease, opacity .35s ease;
    }
  }

  &-enter-from,
  &-leave-to {
    .modal-dialog {
      opacity: 0;
      transform: translateY(toRem(-20));
    }
  }
}
</style>